<nav class="w-full bg-white shadow-md" role="navigation">
  <div class="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center justify-between px-2 py-1 md:py-0">
    <div class="flex items-center justify-between w-full md:w-auto relative">
      <a class="block flex-shrink-0 md:mr-4" [routerLink]="currentCourseLink()">
        <!-- Mobile Logo -->
        <img id="logo-container-mobile" src="{{'assets/img/carlogo.png'}}"
          class="block md:hidden h-14 w-auto max-w-[180px] object-contain" alt="KeystoDriving Logo">
        <!-- Desktop Logo -->
        <img id="logo-container-desktop" src="{{'assets/img/navLogo.jpeg'}}"
          class="hidden md:block h-16 lg:h-20 w-auto max-w-[220px] object-contain" alt="KeystoDriving Logo">
      </a>
      <!-- Hamburger (Mobile) -->
      <div class="md:hidden relative">
        <button (click)="toggleHamburgerMenu()" class="p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-center h-12 w-12 text-gray-800 hover:bg-gray-100 transition-all" aria-label="Menu">
          <mat-icon class="text-3xl">{{ showHamburgerMenu ? 'close' : 'menu' }}</mat-icon>
        </button>
        <!-- Hamburger dropdown: Contact Us + profile links when logged in -->
        <div *ngIf="showHamburgerMenu" class="absolute right-0 top-full mt-1 w-56 bg-white rounded-lg shadow-lg z-50 border border-gray-200 py-1">
          <a *ngIf="isUserLoggedIn && !isSsoLogin" routerLink="/courses" (click)="closeHamburgerMenu()"
            class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Courses</a>
          <a *ngIf="!isUserLoggedIn" href="https://www.keystodriving.com/courses" target="_blank" (click)="closeHamburgerMenu()"
            class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Courses</a>
          <a href="https://www.keystodriving.com/contact-us" target="_blank" (click)="closeHamburgerMenu()"
            class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Contact Us</a>
          <ng-container *ngIf="isUserLoggedIn">
            <div class="border-t border-gray-100 my-0.5"></div>
            <a *ngIf="currentUser && currentUser.memberstatus == 'admin'" routerLink="/admin/dashboard" (click)="closeHamburgerMenu()"
              class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Dashboard</a>
            <a routerLink="/profile" (click)="closeHamburgerMenu()"
              class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Profile</a>
            <a routerLink="/change-password" (click)="closeHamburgerMenu()"
              class="block text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">Change password</a>
            <button (click)="logout(); closeHamburgerMenu();" class="block w-full text-left text-gray-700 hover:bg-gray-100 px-4 py-2 transition-colors">
              Logout
            </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="flex-col md:flex-row items-center w-full md:w-auto mt-2 md:mt-0 md:ml-4 gap-2 md:gap-6 z-20 bg-white md:bg-transparent hidden md:flex">
      <div *ngIf="currentCourse" class="my-2 md:my-0">
        <h5 class="text-black text-base md:text-lg font-semibold">{{ currentCourse?.courseName }}</h5>
      </div>      
      
      <!-- Profile Icon with Dropdown (Desktop) -->
      <div *ngIf="isUserLoggedIn" class="hidden md:block relative">
        <button (click)="toggleProfileMenu()" class="profile-icon-btn p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 z-10 flex items-center justify-center h-12 w-12 text-gray-800 hover:bg-gray-100 transition-all duration-200 overflow-visible" aria-label="Profile Menu">
          <mat-icon class="text-3xl profile-icon">account_circle</mat-icon>
        </button>
        <!-- Desktop Dropdown Menu -->
        <div *ngIf="showProfileMenu" 
          class="profile-dropdown bg-white rounded-lg shadow-lg z-50 border border-gray-200">
          <div class="py-1">
            <a *ngIf="currentUser && currentUser.memberstatus == 'admin'"
               routerLink="/admin/dashboard" 
               (click)="closeProfileMenu()"
               class="profile-menu-item block text-gray-700 hover:bg-gray-100 transition-colors duration-200">
              Dashboard
            </a>
            <a *ngIf="isUserLoggedIn && !isSsoLogin" href="https://www.keystodriving.com/courses" target="_blank" (click)="closeProfileMenu()"
              class="profile-menu-item block text-gray-700 hover:bg-gray-100 transition-colors duration-200">
              Courses
            </a>
            <a routerLink="/profile" 
              (click)="closeProfileMenu()"
              class="profile-menu-item block text-gray-700 hover:bg-gray-100 transition-colors duration-200">
              Profile
            </a>
            <a routerLink="/change-password" 
              (click)="closeProfileMenu()"
              class="profile-menu-item block text-gray-700 hover:bg-gray-100 transition-colors duration-200">
              Change Password
            </a>
            <button (click)="logout(); closeProfileMenu();" 
              class="profile-menu-item block w-full text-left text-gray-700 hover:bg-gray-100 transition-colors duration-200">
              Logout
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="!isUserLoggedIn" class="w-full md:w-auto"> 
        <ul class="flex flex-col md:flex-row items-center gap-2 md:gap-4 w-full md:w-auto">
          <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" href="https://www.keystodriving.com/courses" target="_blank">Courses</a></li>
          <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" href="https://www.keystodriving.com/contact-us" target="_blank">Contact Us</a></li>
          <!-- <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" routerLink="/home/course-Info">About Our Online Course</a></li> -->
           <!-- <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" routerLink="/home/testimoniols">Testimoniols</a></li>  -->
          <!-- <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" routerLink="/home/privacy">Privacy</a></li> -->
          <!-- <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" routerLink="/home/about-us">About Us</a></li> -->
          <!-- <li><a class="block w-full text-black px-4 py-3 rounded transition hover:bg-blue-50 focus:bg-blue-100 border-t md:border-0 text-base md:text-sm" routerLink="/home/contact-us">Contact Us</a></li> -->
        </ul>
      </div>
    </div>
  </div>
</nav>
